(() => {
    angular
        .module('app')
        .component('clinicHospitalQueryQueryItemComponent', {
            templateUrl: require('./queryItem.component.html'),
            controller: QueryItemController,
            controllerAs: 'vm',
            bindToController: true,
            bindings: {
                item: '<',
                isTenantFromHub: '<'
            }
        });

    QueryItemController.$inject = [
        'abp.services.app.serviceRequestQuery', 
        'Hms.ServiceRequests.ServiceRequestQueryItemType', 
        'abp.services.app.commonLookup'
    ];

    function QueryItemController(
        serviceRequestQuerySvc,
        enumServiceRequestQueryItemType,
        commonLookupSvc
    ) {
        const vm = this;
        vm.exporting = 0;
        vm.loading = 0;
 
        vm.downloadMedicalQueryForm = downloadMedicalQueryForm;
 
        vm.enums = {};
        vm.enums.serviceRequestQueryItemType = enumServiceRequestQueryItemType;
 
        vm.hasInpatientRegionalExpansion = abp.setting.getBoolean(
            'Hms.Feature.RegionalExpansionForInpatient');
 
        init();
 
        function init() {
            if (vm.hasInpatientRegionalExpansion && commonLookupSvc && typeof commonLookupSvc.getDefaultLanguageByCountryCode === 'function') {
                getLanguage();
            }
        }
 
        function getLanguage() {
            vm.loading += 1;
            if (!commonLookupSvc || typeof commonLookupSvc.getDefaultLanguageByCountryCode !== 'function') {
                vm.loading -= 1;
                return;
            }
            commonLookupSvc
                .getDefaultLanguageByCountryCode()
                .success((data) => { vm.language = data; })
                .finally(() => { vm.loading -= 1; });
        }
 
        function downloadMedicalQueryForm(language) {
            vm.exporting += 1;
            serviceRequestQuerySvc.getMedicalQueryFormPdf({ 
                id: vm.item.id, 
                languageCode: language 
                }).success((data) => {
                    App.downloadTempFile(data);
                }).finally(() => {
                    vm.exporting -= 1;
                });
        }
    }
})();